import { IonRouterLink } from '@ionic/react';
import React, { useState } from 'react';

import { Icon, Text } from '@/components/memo';
import { bulbOutline } from 'ionicons/icons';

import './Tips.css';

interface TipsProps {
  content: React.ReactNode[];
  onHide?: () => void;
  onNext?: () => void;
  showNextButton?: boolean;
  showHideButton?: boolean;
}

const Tips: React.FC<TipsProps> = ({
  content = [],
  onHide,
  showNextButton = true,
  showHideButton = true
}) => {
  const [currentTipIndex, setCurrentTipIndex] = useState<number>(0);

  const onNext = () => {
    setCurrentTipIndex((prevIndex) => (prevIndex + 1) % content.length);
  };

  return (
    <div className="tip">
      <div className="tip__content">
        <div className="tip__icon">
          <Icon icon={bulbOutline} />
        </div>
        <div className="tip__text">
          <Text>Tip:</Text> {content[currentTipIndex]}
        </div>
      </div>
      {(showHideButton || showNextButton) && (
        <div className="tip__actions">
          {showHideButton && onHide && (
            <IonRouterLink onClick={onHide}>Do not show again</IonRouterLink>
          )}
          {showNextButton && (
            <IonRouterLink onClick={onNext}>Next</IonRouterLink>
          )}
        </div>
      )}
    </div>
  );
};

export default Tips;
